import React from "react";
import KakaoMap from "./KakaoMap.js";
import "../sass/home.scss";

function Home() {
  return (
    <>
      <div className="banner">
        <ul>
          <li>
            <img className="pcimg" src="/image/slide01.jpg" alt="" />
            <img className="moimg" src="/image/moslide01.jpg" alt="" />
            <div className="content">
              <p>
                365일 24시간, <br />
                언제나 친절하고 전문적인 상담 <br />
                청라맑은 비뇨의학과
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="clinicList">
        <div className="wrap">
          <h2>진료항목</h2>
          <h3>(365일, 24시간 응급 체외충격파쇄석술)</h3>

          <ul>
            <li>
              <img src="/image/clinic01.jpg" alt="" />
              <div className="content">
                <p>
                  출산의 고통과 <br />
                  견줄만한 극심한 통증
                </p>
                <h4>요로결석</h4>
              </div>
            </li>
            <li>
              <img src="/image/clinic02.jpg" alt="" />
              <div className="content">
                <p>
                  정밀한 진단과 <br />
                  정확한 치료
                </p>
                <h4>전립선</h4>
              </div>
            </li>
            <li>
              <img src="/image/clinic03.jpg" alt="" />
              <div className="content">
                <p>
                  다각도로 진단하여 <br />
                  치료의 높은 정확도
                </p>
                <h4>비뇨질환</h4>
              </div>
            </li>
            <li>
              <img src="/image/clinic04.jpg" alt="" />
              <div className="content">
                <p>
                  각종 비뇨기 질환의 <br />
                  시발점으로 불임의 원인
                </p>
                <h4>성기능클리닉</h4>
              </div>
            </li>
            <li>
              <img src="/image/clinic05.jpg" alt="" />
              <div className="content">
                <p>
                  각 연령과 질환에 맞는 <br />
                  체계적인 치료
                </p>
                <h4>여성비뇨 질환</h4>
              </div>
            </li>
            <li>
              <img src="/image/clinic06.jpg" alt="" />
              <div className="content">
                <p>
                  다양한 치료 래퍼런스로 <br />
                  통증의 최소화를 지향
                </p>
                <h4>피부질환</h4>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="contact">
        <div className="wrap2">
          <ul>
            <li>
              <h2>
                <b><img src="/image/loction.png" alt="" />찾아오시는길</b>
                <p>대구광역시 중구 달구벌대로 1988-3, 5층 2호선 청라언덕역 2번 출구 앞</p>
              </h2>
              {KakaoMap(35.864229, 128.581579, "mainMap")}
            </li>
            <li>
              <form action="/mail/mail.php" method="post">
                <h2>온라인 1:1 문의하기</h2>

                <div>
                  <div>
                    <label >
                      <span>이름</span>
                      <input type="text" name="name"/>
                    </label>
                    <label >
                      <span>연락처</span>
                      <input type="text" name="tel"/>
                    </label>
                  </div>

                  <label>
                    <span>진료과목</span>
                    <div className="selectBox">
                      <select name="subject">
                        <option value="선택안함">선택해주세요</option>
                        <option value="요로결석">요로결석</option>
                        <option value="전립선">전립선</option>
                        <option value="혈뇨">혈뇨</option>
                        <option value="성병">성병</option>
                        <option value="남성클리닉">남성클리닉</option>
                        <option value="여성클리닉">여성클리닉</option>
                        <option value="소아클리닉">소아클리닉</option>
                      </select>
                      <i class="fa-solid fa-chevron-down"></i>
                    </div>
                  </label>

                  <label className="text">
                    <span>문의내용</span>
                    <textarea name="context"></textarea>
                  </label>
                </div>
                  <button type="submit">
                    <img src="/image/submit.png" alt="" />
                    <span>빠른 상담신청</span>
                  </button>
              </form>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Home;